(() => {
  const story = document.querySelector('[data-commander-story]');
  if (!story) return;
  const nav = story.querySelector('.cg-nav');
  const header = document.querySelector('[data-site-header]');
  const links = [...story.querySelectorAll('.cg-nav-links a')];
  const navLinks = story.querySelector('.cg-nav-links');
  let previousActive = -1, previousNavWidth = -1;
  const targets = links.map(link => document.getElementById(link.hash.slice(1)));
  let scheduled = false;
  let previousOffset = -1;
  let previousHeight = -1;
  const update = () => {
    scheduled = false;
    const headerRect = header?.getBoundingClientRect();
    const offset = headerRect && headerRect.top <= 1 ? Math.max(0, headerRect.bottom) : 0;
    const height = nav.getBoundingClientRect().height;
    if (offset !== previousOffset) {
      story.style.setProperty('--cg-header-offset', `${offset}px`);
      previousOffset = offset;
    }
    if (height !== previousHeight) {
      story.style.setProperty('--cg-nav-height', `${height}px`);
      previousHeight = height;
    }
    let active = 0;
    targets.forEach((target, index) => {
      if (target && target.getBoundingClientRect().top <= offset + height + 60) active = index;
    });
    links.forEach((link, index) => {
      if (index === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    // Scroll only the label strip, never the page, when the active chapter changes.
    const navWidth = navLinks.clientWidth;
    if (active !== previousActive || navWidth !== previousNavWidth) {
      previousActive = active;
      previousNavWidth = navWidth;
      const current = links[active];
      if (current && navWidth && navLinks.scrollWidth > navWidth) {
        const strip = navLinks.getBoundingClientRect();
        const label = current.getBoundingClientRect();
        const left = label.left - strip.left - 12;
        const right = label.right - strip.right + 12;
        const delta = label.width > navWidth - 24 ? left : left < 0 ? left : right > 0 ? right : 0;
        if (delta) navLinks.scrollBy({
          left: delta,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    }
  };
  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    observer.observe(nav);
    if (header) observer.observe(header);
  }
  update();

  // Content stays visible without JavaScript or when reduced motion is requested.
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver;
  const revealTargets = [...story.querySelectorAll(
    '.cg-hero, .cg-feature > figure, .cg-feature-copy, .cg-section-heading, ' +
    '.cg-mode-grid > article, .cg-fit-grid > article, .cg-connection-grid > div, ' +
    '.cg-device-guide > article, .cg-noise-paths > article, .cg-tuning-grid > article, ' +
    '.cg-start-steps > li, .cg-battery-number'
  )];
  const configureMotion = () => {
    revealObserver?.disconnect();
    revealTargets.forEach(target => target.classList.remove('cg-enter'));
    if (motionPreference.matches || !('IntersectionObserver' in window)) return;
    revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cg-enter');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    revealTargets.forEach(target => {
      // Don't replay an entrance on content already visible when opening an anchor.
      if (target.getBoundingClientRect().top < window.innerHeight) return;
      const siblings = [...target.parentElement.children].filter(child => revealTargets.includes(child));
      target.style.setProperty('--cg-reveal-delay', `${Math.min(siblings.indexOf(target), 3) * 75}ms`);
      revealObserver.observe(target);
    });
  };
  configureMotion();
  motionPreference.addEventListener('change', configureMotion);
})();
